import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";

export const useStatusOptions = (): FilterFieldOptionsHookResult => {
  const { t } = useTranslation();

  const options = useMemo<FilterFieldOption[]>(
    () => [
      { value: "active", label: t("users.active") },
      { value: "removed", label: t("users.removed") },
    ],
    [t],
  );

  return { options };
};
